import React, { Component } from 'react';
import './style.css';

class MembersList extends Component {
  constructor(props){
    super(props)
    this.state={
    };
    this.editMember = this.editMember.bind(this);
  }

  editMember(data){
    this.props.editMember(data);
  }

  render(){

    let membersDataList = "";
    if(this.props.success){
    if(this.props.membersList && this.props.membersList.length){
        let members = this.props.membersList;
        membersDataList = Object.keys(members).map((item, index) => {
        let membersItem = members[item];

        return <tr key={index} >
          <td>{membersItem.First_name + " "+ membersItem.Last_name}</td>
          <td>{membersItem.D_O_B}</td>
          <td>{membersItem.Gender}</td>
          <td>{membersItem.Marriage_status}</td>
          <td>{membersItem.Address_line_one}</td>
          <td>{membersItem.State}</td>
          <td>{membersItem.Country}</td>
          <td>{membersItem.Pincode}</td>
          <td><button className = "edituserbtn" type="button" onClick={this.editMember.bind(this, membersItem)}  > Edit </button></td>
          </tr>
          });
    }
  }else{
    membersDataList =
      <div>
      Not found  register Members please approved new Member
      </div>
  }

  return (<div className = "userlist">
  <div className = "userlistbackground">
        <div className = "usertable"><h1>Registered Users List</h1></div>
        <div className = "autoscroll">
        <table className = "customerTable">
          <thead>
            <tr>
              
              <th>Name</th>
              <th>D.O.B</th>
              <th>Gender</th>
              <th>Marriage</th>
              <th>Address</th>
              <th>State/Province</th>
              <th>Country</th>
              <th>Pincode</th>
              <th>Action</th>
            </tr>
          </thead>
            <tbody>
              {membersDataList}
            </tbody>
        </table>
        </div>
        </div>
        </div>
        
    );
  }
}
export default MembersList;



// WEBPACK FOOTER //
// ./src/components/members/index.js